import React, { useState, useEffect } from "react";
import "./ContactForm.css";
import emailjs from "emailjs-com";

const ContactForm = () => {
    const [formData, setFormData] = useState({ to_name: "", to_email: "", message: "" });
    const [notification, setNotification] = useState({ message: "", type: "" });

    useEffect(() => {
        if (notification.message) {
            // Efface la notification après 20 secondes
            const timer = setTimeout(() => {
                setNotification({ message: "", type: "" });
            }, 20000); // Durée ajustée : ici 20000ms (20 secondes)

            return () => clearTimeout(timer); // Nettoie le timer si le composant est démonté
        }
    }, [notification]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_vd7ot1o",
                "template_5blv27j",
                e.target,
                "a4KIlupbWIDHeUIIw"
            )
            .then(
                () => {
                    setNotification({ message: "Votre message a bien été envoyé !", type: "success" });
                    setFormData({ name: "", email: "", message: "" });
                },
                () => {
                    setNotification({ message: "Erreur lors de l'envoi du message.", type: "error" });
                }
            );
    };

    return (
        <div className="contact-form">
            <h2>Contactez-nous</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Nom</label>
                    <input
                        type="text"
                        id="name"
                        name="to_name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Votre nom"
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        name="to_email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Votre email"
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Votre message"
                        required
                    ></textarea>
                </div>
                <button type="submit">Envoyer</button>
            </form>

            {/* Notification */}
            {notification.message && (
                <div className={`notification ${notification.type}`}>
                    {notification.message}
                </div>
            )}
        </div>
    );
};

export default ContactForm;
